import React from 'react';
import {useFormContext as useFormContextOriginal} from '../../lib/react-hook-form';
import {useIntl} from '@sail/intl';
import type {FieldValues, UseFormReturn} from './types';
import {applyDefaultValidationMessages} from './defaultValidationMessages';

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
>(): UseFormReturn<TFieldValues> | null {
  const formContext = useFormContextOriginal<TFieldValues>();
  const {formatMessage} = useIntl();

  return React.useMemo(() => {
    if (!formContext || !('__sailFormContext' in formContext)) {
      return null;
    }

    // Extract public methods
    const {trigger, subscribe, register, setFocus, ...publicMethods} =
      formContext;

    return {
      ...publicMethods,
      validate: trigger,
      field: (name, rules) => ({
        name,
        rules: applyDefaultValidationMessages(formatMessage, rules),
      }),
      __internal: {
        subscribe,
        register,
        setFocus,
      },
    };
  }, [formContext, formatMessage]);
}
